import { BROADCAST_SET_SESSION_ID } from 'actions/Types';

export default (state = null, action) => {
  if (action.type === BROADCAST_SET_SESSION_ID) {
    return action?.payload || state;
  }

  return state;
};
